(function () {
  'use strict';

  var root;
  var context = 'preference';
  var cartTarget = null;
  var lastFocus = null;
  var busy = false;

  function clean(value) { return String(value == null ? '' : value).replace(/\s+/g, ' ').trim(); }
  function cleanAdjustment(value) {
    var adjustment = clean(value);
    return /^(?:none|no adjustments?)$/i.test(adjustment) ? '' : adjustment;
  }
  function parse(value) { try { return JSON.parse(value || '{}') || {}; } catch (error) { return {}; } }
  function parseCartProperties(value) {
    var source = typeof value === 'string' ? parse(value) : value;
    var properties = {};
    function copy(key, entry) {
      key = String(key || '');
      if (!key || /^\d+$/.test(key) || key === '__proto__' || key === 'constructor' || key === 'prototype') return;
      properties[key] = entry;
    }
    if (Array.isArray(source)) {
      source.forEach(function (pair) {
        if (Array.isArray(pair) && pair.length > 1) copy(pair[0], pair[1]);
      });
    } else if (source && typeof source === 'object') {
      Object.keys(source).forEach(function (key) { copy(key, source[key]); });
    }
    return properties;
  }
  function selected(name) {
    var input = root && root.querySelector('input[name="' + name + '"]:checked');
    return input ? input.value : '';
  }
  function field(name) { return root && root.querySelector('[data-jmt-quick-fit-field="' + name + '"]'); }
  function errorNode() { return root && root.querySelector('[data-jmt-quick-fit-error]'); }

  function normalizeSelection(source) {
    source = source && typeof source === 'object' ? source : {};
    return {
      pouchStyle: clean(source.pouchStyle || source.cut),
      waistSize: clean(source.waistSize || source.size).split(/\s+/)[0],
      thongStrapStyle: clean(source.thongStrapStyle || source.strapStyle),
      pouchAdjustment: cleanAdjustment(source.pouchAdjustment || (source.adjustments && source.adjustments.pouch)),
      backStrapAdjustment: cleanAdjustment(source.backStrapAdjustment || (source.adjustments && source.adjustments.backStrap))
    };
  }

  function currentSelection() {
    return {
      pouchStyle: selected('jmt-quick-pouch'),
      waistSize: field('waistSize').value,
      thongStrapStyle: selected('jmt-quick-back'),
      pouchAdjustment: field('pouchAdjustment').value,
      backStrapAdjustment: field('backStrapAdjustment').value
    };
  }

  function chooseRadio(name, value) {
    root.querySelectorAll('input[name="' + name + '"]').forEach(function (input) {
      input.checked = clean(input.value).toLowerCase() === clean(value).toLowerCase();
    });
  }

  function refreshSelectedLabels() {
    var pouch = root.querySelector('[data-jmt-quick-fit-selected="pouchStyle"]');
    var back = root.querySelector('[data-jmt-quick-fit-selected="thongStrapStyle"]');
    if (pouch) pouch.textContent = selected('jmt-quick-pouch');
    if (back) back.textContent = selected('jmt-quick-back');
  }

  function refreshBackAdjustments() {
    var size = field('waistSize').value;
    var back = field('backStrapAdjustment');
    if (!back) return;
    var allowed = window.JMT_PRODUCTION && window.JMT_PRODUCTION.allowedBackAdjustments
      ? window.JMT_PRODUCTION.allowedBackAdjustments(size)
      : [-2, -1, 0, 1, 2];
    Array.prototype.forEach.call(back.options, function (option) {
      var numeric = Number(option.value || 0);
      option.disabled = Boolean(size) && allowed.indexOf(numeric) === -1;
    });
    if (back.selectedOptions.length && back.selectedOptions[0].disabled) back.value = '';
    syncAdjustmentSummary();
  }

  function adjustmentText(value) {
    value = cleanAdjustment(value);
    if (!value) return 'No adjustment';
    if (/^[+-]?\d+$/.test(value)) return value + (Math.abs(Number(value)) === 1 ? ' inch' : ' inches');
    return value;
  }

  function syncAdjustmentSummary() {
    if (!root) return;
    var summary = root.querySelector('[data-jmt-selected-adjustments]');
    if (!summary) return;
    var pouch = field('pouchAdjustment').value;
    var back = field('backStrapAdjustment').value;
    summary.hidden = !cleanAdjustment(pouch) && !cleanAdjustment(back);
    summary.querySelector('[data-jmt-selected-adjustment="pouchAdjustment"]').textContent = 'Pouch depth: ' + adjustmentText(pouch);
    summary.querySelector('[data-jmt-selected-adjustment="backStrapAdjustment"]').textContent = 'Back-strap length: ' + adjustmentText(back);
  }

  function adjustmentModal() { return document.querySelector('[data-jmt-adjustment-modal]'); }

  function setModalAdjustments(selection, restrictBack) {
    var modal = adjustmentModal();
    if (!modal) return;
    var pouch = modal.querySelector('[data-jmt-adjustment="pouchAdjustment"]');
    var back = modal.querySelector('[data-jmt-adjustment="backStrapAdjustment"]');
    if (pouch) pouch.value = cleanAdjustment(selection && selection.pouchAdjustment);
    if (!back) return;
    Array.prototype.forEach.call(back.options, function (option) { option.disabled = false; });
    if (restrictBack && field('waistSize').value && window.JMT_PRODUCTION && window.JMT_PRODUCTION.allowedBackAdjustments) {
      var allowed = window.JMT_PRODUCTION.allowedBackAdjustments(field('waistSize').value);
      Array.prototype.forEach.call(back.options, function (option) {
        option.disabled = allowed.indexOf(Number(option.value || 0)) === -1;
      });
    }
    back.value = cleanAdjustment(selection && selection.backStrapAdjustment);
    if (back.selectedOptions.length && back.selectedOptions[0].disabled) back.value = '';
  }

  function resetModalAdjustments() {
    var modal = adjustmentModal();
    if (!modal || !modal.hasAttribute('data-jmt-quick-fit-context')) return;
    modal.removeAttribute('data-jmt-quick-fit-context');
    setModalAdjustments(window.JMT_PREF && window.JMT_PREF.get ? window.JMT_PREF.get() : {}, false);
  }

  function openAdjustments() {
    var modal = adjustmentModal();
    var button = root.querySelector('[data-jmt-quick-fit-adjustment-open]');
    if (!modal || !window.JMTAdjustmentModal || typeof window.JMTAdjustmentModal.open !== 'function') {
      showError('Optional adjustments could not open. Please try again.');
      return;
    }
    showError('');
    modal.setAttribute('data-jmt-quick-fit-context', context);
    setModalAdjustments(currentSelection(), true);
    window.JMTAdjustmentModal.open(button);
  }

  function hydrate(selection) {
    var value = normalizeSelection(selection);
    chooseRadio('jmt-quick-pouch', value.pouchStyle || 'Classic');
    chooseRadio('jmt-quick-back', value.thongStrapStyle || 'Original');
    refreshSelectedLabels();
    field('waistSize').value = value.waistSize || '';
    field('pouchAdjustment').value = value.pouchAdjustment || '';
    field('backStrapAdjustment').value = value.backStrapAdjustment || '';
    refreshBackAdjustments();
    syncAdjustmentSummary();
    showError('');
  }

  function showError(message) {
    var node = errorNode();
    if (!node) return;
    node.textContent = message || '';
    node.hidden = !message;
  }

  function setBusy(next) {
    busy = Boolean(next);
    var button = root.querySelector('[data-jmt-quick-fit-save]');
    button.disabled = busy;
    button.setAttribute('aria-busy', busy ? 'true' : 'false');
    button.textContent = busy ? 'Saving…' : (context === 'cart' ? 'Update Item' : 'Save Quick Add Fit');
  }

  function open(source, options) {
    if (!root) return;
    options = options || {};
    context = options.context === 'cart' ? 'cart' : 'preference';
    cartTarget = context === 'cart' ? (options.cartTarget || null) : null;
    var selection = options.selection;
    if (!selection && context === 'preference' && window.JMT_PREF && window.JMT_PREF.get) selection = window.JMT_PREF.get();
    hydrate(selection || {});
    root.querySelector('#jmt-quick-fit-title').textContent = context === 'cart' ? 'Edit your fit' : 'Choose your fit';
    root.querySelector('[data-jmt-quick-fit-eyebrow]').textContent = context === 'cart' ? 'This item only' : 'Quick Add fit';
    root.querySelector('[data-jmt-quick-fit-note]').textContent = context === 'cart'
      ? 'Update the fit for this item without changing your saved Quick Add fit.'
      : 'Choose your pouch, waist size, and back style.';
    root.querySelector('[data-jmt-quick-fit-save]').textContent = context === 'cart' ? 'Update Item' : 'Save Quick Add Fit';
    lastFocus = document.activeElement;
    root.hidden = false;
    document.documentElement.classList.add('jmt-quick-fit-open');
    root.querySelector('.jmt-quick-fit__body').scrollTop = 0;
    window.requestAnimationFrame(function () {
      root.querySelector('.jmt-quick-fit__dialog').focus({ preventScroll: true });
    });
  }

  function close() {
    if (!root || root.hidden || busy) return;
    root.hidden = true;
    document.documentElement.classList.remove('jmt-quick-fit-open');
    resetModalAdjustments();
    cartTarget = null;
    showError('');
    window.dispatchEvent(new CustomEvent('jmt:quick-fit:closed', { detail: { context: context } }));
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  function cartUpdateUrl() { return window.routes && window.routes.cart_change_url ? window.routes.cart_change_url : '/cart/change.js'; }

  function fetchProduct(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin', headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('This product could not be loaded.');
      return response.json();
    });
  }

  function findVariant(product, selection) {
    if (!window.JMT_VARIANTS) return null;
    var choices = {};
    window.JMT_VARIANTS.optionNames(product).forEach(function (name) {
      var role = window.JMT_VARIANTS.role(name);
      if (role === 'pouchStyle') choices[name] = selection.pouchStyle;
      if (role === 'waistSize') choices[name] = selection.waistSize;
      if (role === 'thongStrapStyle') choices[name] = selection.thongStrapStyle;
    });
    return window.JMT_VARIANTS.findVariant(product, choices, { availableOnly: true, requireAll: true });
  }

  function cartProperties(product, variant, selection) {
    var properties = parseCartProperties(cartTarget && cartTarget.properties);
    delete properties['Pouch size adjustment'];
    delete properties['Thong strap length adjustment'];
    if (selection.pouchAdjustment) properties['Pouch size adjustment'] = selection.pouchAdjustment;
    if (selection.backStrapAdjustment) properties['Thong strap length adjustment'] = selection.backStrapAdjustment;
    if (!window.JMT_PRODUCTION) return properties;
    var input = window.JMT_PRODUCTION.inputFromProductVariant(product, variant, {
      pouchAdjustment: selection.pouchAdjustment,
      backStrapAdjustment: selection.backStrapAdjustment
    });
    var result = window.JMT_PRODUCTION.withProductionProperties(properties, input);
    if (!result.ok) throw new Error(result.message || 'That adjustment is not available for this size.');
    return result.properties;
  }

  function requestJson(url, body) {
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (payload) {
        if (!response.ok || payload.errors) throw new Error(payload.description || payload.errors || 'This fit could not be saved.');
        return payload;
      });
    });
  }

  function renderCart(response) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && response && response.sections) drawer.renderContents(response);
    window.dispatchEvent(new CustomEvent('jmt:cart:refresh'));
    window.dispatchEvent(new CustomEvent('jmt:cart:changed'));
  }

  function saveCart(selection) {
    if (!cartTarget || !cartTarget.handle || !cartTarget.key) return Promise.reject(new Error('This item cannot be edited right now.'));
    var product;
    var variant;
    var properties;
    return fetchProduct(cartTarget.handle).then(function (loadedProduct) {
      product = loadedProduct;
      variant = findVariant(product, selection);
      if (!variant) throw new Error('That fit combination is not currently available.');
      properties = cartProperties(product, variant, selection);
      if (Number(cartTarget.variantId) === Number(variant.id)) {
        return requestJson(cartUpdateUrl(), {
          id: cartTarget.key,
          quantity: Number(cartTarget.quantity) || 1,
          properties: properties,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname
        });
      }
      return requestJson('/cart/add.js', {
        items: [{ id: variant.id, quantity: Number(cartTarget.quantity) || 1, properties: properties }]
      }).then(function () {
        return requestJson(cartUpdateUrl(), {
          id: cartTarget.key,
          quantity: 0,
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname
        });
      });
    }).then(function (response) {
      root.hidden = true;
      document.documentElement.classList.remove('jmt-quick-fit-open');
      resetModalAdjustments();
      cartTarget = null;
      renderCart(response);
    });
  }

  function save() {
    if (busy) return;
    var selection = currentSelection();
    if (!selection.pouchStyle || !selection.waistSize || !selection.thongStrapStyle) {
      showError('Choose a pouch style, waist size, and back style.');
      if (!selection.pouchStyle) root.querySelector('input[name="jmt-quick-pouch"]').focus();
      else if (!selection.waistSize) field('waistSize').focus();
      else root.querySelector('input[name="jmt-quick-back"]').focus();
      return;
    }
    showError('');
    if (context === 'preference') {
      if (!window.JMT_PREF || typeof window.JMT_PREF.set !== 'function') {
        showError('Your fit could not be saved. Please try again.');
        return;
      }
      window.JMT_PREF.set(selection);
      window.dispatchEvent(new CustomEvent('jmt:quick-fit:saved', { detail: { context: context } }));
      close();
      return;
    }
    setBusy(true);
    saveCart(selection).catch(function (error) {
      showError(error && error.message || 'This fit could not be saved.');
    }).finally(function () { setBusy(false); });
  }

  function optionsFromTrigger(trigger) {
    var options = { context: trigger.hasAttribute('data-jmt-cart-edit') ? 'cart' : 'preference' };
    if (options.context === 'cart') {
      options.selection = parse(trigger.getAttribute('data-jmt-selection'));
      options.cartTarget = {
        key: trigger.getAttribute('data-cart-key'),
        handle: trigger.getAttribute('data-product-handle'),
        variantId: trigger.getAttribute('data-variant-id'),
        quantity: trigger.getAttribute('data-quantity'),
        properties: trigger.getAttribute('data-properties')
      };
    }
    return options;
  }

  function trapFocus(event) {
    if (!root || root.hidden || event.key !== 'Tab') return;
    var focusable = Array.prototype.filter.call(root.querySelectorAll('button:not([disabled]), select:not([disabled]), input:not([disabled]), summary'), function (node) {
      return node.offsetParent !== null;
    });
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }

  function ready() {
    root = document.getElementById('jmt-quick-fit');
    if (!root) return;
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-jmt-quick-fit-open]');
      if (!trigger) return;
      event.preventDefault();
      open(trigger.dataset.sourceContext || 'quick_fit', optionsFromTrigger(trigger));
    });
    root.querySelectorAll('[data-jmt-quick-fit-close]').forEach(function (button) { button.addEventListener('click', close); });
    root.querySelector('[data-jmt-quick-fit-save]').addEventListener('click', save);
    root.querySelector('[data-jmt-quick-fit-adjustment-open]').addEventListener('click', openAdjustments);
    root.querySelectorAll('input[name="jmt-quick-pouch"], input[name="jmt-quick-back"]').forEach(function (input) {
      input.addEventListener('change', refreshSelectedLabels);
    });
    field('waistSize').addEventListener('change', refreshBackAdjustments);
    root.querySelectorAll('[data-jmt-quick-fit-field="pouchAdjustment"], [data-jmt-quick-fit-field="backStrapAdjustment"]').forEach(function (input) {
      input.addEventListener('change', syncAdjustmentSummary);
    });
    document.addEventListener('change', function (event) {
      if (root.hidden || !event.target.closest('[data-jmt-adjustment-modal][data-jmt-quick-fit-context]')) return;
      syncAdjustmentSummary();
    });
    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { event.preventDefault(); close(); }
      else trapFocus(event);
    });
    window.JMT_QUICK_FIT = { open: open, close: close };
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', ready) : ready();
})();
